import { render, staticRenderFns } from "./legalFace.vue?vue&type=template&id=60ae1251&scoped=true&"
import script from "./legalFace.vue?vue&type=script&lang=js&"
export * from "./legalFace.vue?vue&type=script&lang=js&"
import style0 from "./legalFace.vue?vue&type=style&index=0&id=60ae1251&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ae1251",
  null
  
)

export default component.exports